<template>
  <div class="mm-page-main"   v-loading="mso_id==0" :element-loading-text="'請先添加牌照MSO和門店'" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
    <div class="page-header">
      <div class="page-title">員工賬號</div>
      <div>
        <el-link @click="gotoruter('/AddUser')" type="primary"><i class="el-icon-circle-plus"></i>添加賬號</el-link>
      </div>
    </div>
    <search :form="form"></search>
    <div class="pagemain">
      <div class="pagetablebox">
        <el-table empty-text="暫無數據" :data="userdata" border :header-cell-style="{background:'#FAFAFA'}">
           <el-table-column prop="thumb" label="頭像" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">頭像</div>
              <div><img v-if="scope.row.thumb" :src="apiurl+scope.row.thumb" alt="" style="height:30px;"></div>
            </template>
          </el-table-column>
          <el-table-column prop="usernum" label="員工編號" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">員工編號</div>
              <div>{{scope.row.usernum}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="username" label="賬號" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">賬號</div>
              <div>{{scope.row.username}}</div>
            </template>
          </el-table-column>
         
          <el-table-column prop="name" label="姓名" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">姓名</div>
              <div>{{scope.row.name}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="email" label="郵箱" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">郵箱</div>
              <div>{{scope.row.email}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="電話" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">電話</div>
              <div>{{scope.row.phone}}</div>
            </template>
          </el-table-column>
          <el-table-column sortable prop="sex" label="性別" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">性別</div>
              <div v-if="scope.row.sex == 0">男</div>
              <div v-else>女</div>
            </template>
          </el-table-column>
          <el-table-column sortable prop="age" label="年齡" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">年齡</div>
              <div>{{scope.row.age}}</div>
            </template>
          </el-table-column>
          <el-table-column sortable prop="status" label="狀態" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">狀態</div>
              <el-switch disabled="" v-model="scope.row.status" active-text="啟用" inactive-text="禁用"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <div class="phonecel">操作</div>
              <el-button size="mini" @click="edit(scope.row.id)">編輯</el-button>
            </template>

          </el-table-column>
        </el-table>
      </div>
      <div class="page-bottom" style="margin-top:15px;">
        <div>
          Total: {{pager.p_count}}個賬號

        </div>
        <div></div>
        <div>
          <el-pagination background @size-change="changesize" @current-change="changepage" :current-page="pager.p_now" :page-sizes="[5, 10, 20, 50]" :page-size="parseInt(pager.p_size)" layout="sizes, prev, pager, next, jumper" :total="pager.p_count">
          </el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import search from "./components/search.vue";
export default {
  components: {
    search
  },
  data () {
    return {
      mso_id:0,
      loading: false,
			userdata: [],
			form:{
				condition:''
			},
      page: 1,
      pagesize: 10,
      pager: [],
    }
  },
  methods: {
    changepage (val) {
      this.page = val;
      this.getuserdata();
    },
    changesize (val) {
      this.pagesize = val;
      this.getuserdata();
    },
    edit (id) {
      this.$router.push({
        name: '/EditUser',
        path: '/EditUser',
        params: {
          id: id
        }
      })
    },
    gotoruter (name) {
      this.$router.push(name)
    },
    getuserdata () {
      let mso_id = sessionStorage.getItem('mso_id');
      this.loading = true;
      this.post('/api/user/index', {
        mso_id:mso_id,
        page: this.page,
				pagesize: this.pagesize,
				condition: this.form.condition
      }).then((res) => {
        console.log(res);
        if (res.info.length > 0) {
          res.info.map((v) => {
            if (v.status == 0) {
              v.status = true;

            } else if (v.status == 1) {
              v.status = false;
            }

          })

          this.userdata = res.info;
          this.pager = res.pager;
        } else {
          this.userdata = [];
          this.pager = [];

        }
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
        console.log(err)
      });
    }
  },
  created () {
    this.mso_id = sessionStorage.getItem('mso_id');
    this.getuserdata();
	},
	watch: {
    'form.condition' (val) {
			this.getuserdata();
		},
	}
}
</script>

<style scoped>
</style>
